function getPDFURL(pdfFile: string): string {
    return pdfFile;
  }
export default getPDFURL;